/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import Loading from '../../Loading';
import { executeEnterEvent, countTitle } from '../utils';
import { findParentTd } from '@platform/api';

export default class ReferDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = { currentIndex: -1 };
        this.time = 0;
    }

    componentWillUnmount() {
        this.referScroll = null;
        this.lifecycleStatus = 'unmount';
    }

    componentWillMount() {
        this.lifecycleStatus = 'mount';
    }

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    componentWillReceiveProps(nextProps) {
        if (!nextProps.dropDownShow || !nextProps.data.length) {
            this.setState({ currentIndex: -1 })
        }
    }

    render() {
        let {
                selectedValues,
                loading,
                onItemClick,
                onItemDoubleClick,
                title,
                columnsTitle,
                data,
                noData,
                footer,
                getStatus,
                isMultiSelectedEnabled,
                containerDom,
                onEnter,
                width,
                dropDownShow,
                searchKey,
            } = this.props,
            {
                isSelectedStatus: isSelectedShow,
                isHistoryStatus,
                isSearchStatus,
            } = getStatus(),
            { currentIndex } = this.state,
            nodataFlag =
				(isHistoryStatus || isSearchStatus) && !loading && !data.length;
        const MIN_INDEX = 0,
            MAX_INDEX = data.length - 1;
        let extraStyle = {};
        if (width < 280) {
            extraStyle = {
                minWidth: width,
                maxWidth: 280,
            };
        } else {
            extraStyle = { width };
        }
        return [
            <div
                className="refer-cascading-list"
                style={{
                    ...extraStyle,
                    display: 'flex',
                    height: nodataFlag && '40px',
                }}
                onMouseDown={e => {
                    e.preventDefault();
                }}
            >
                <Loading container={this} show={false} />
                <div className="scroll-div">
                    {nodataFlag ? (
                        <p className="refer-nodata list-title">{noData}</p>
                    ) : (
                        [
                            <p className="list-title" title={title + columnsTitle}>
                                {title}
                                <span>{columnsTitle}</span>
                            </p>,
                            <div
                                className="refer-scroll"
                                ref={dom => {
                                    this.referScroll = dom;
                                }}
                            >
                                <ul className="refer-cascading-item">
                                    {data.map((item, i) => {
                                        let label =
											dropDownShow && typeof searchKey === 'string'
											    ? countTitle(item.label, searchKey)
											    : item.label;
                                        return (
                                            <li
                                                title={item.label}
                                                className={
                                                    'clearfix refer-li' +
													// 新增：单选参照输入框没值时不加背景色
													((searchKey) &&
													!isSelectedShow &&
													selectedValues.has(item.refpk)
													    ? ' selected'
													    : '') +
													(currentIndex === i ? ' focused' : '')
                                                }
                                                key={i}
                                                onClick={() => {
                                                    if (!this.timer) {
                                                        this.timer = setTimeout(() => {
                                                            clearTimeout(this.timer);
                                                            this.timer = 0;
                                                            onItemClick(item);
                                                        }, 300)
                                                    }
                                                }}
                                                onDoubleClick={() => {
                                                    clearTimeout(this.timer);
                                                    this.timer = 0;
                                                    onItemDoubleClick(item)
                                                }}
                                            >
                                                {label}
                                                {isSelectedShow && (
                                                    <i className="refer-del-i iconfont icon-qingkong" />
                                                )}
                                            </li>
                                        );
                                    })}
                                    {(isHistoryStatus || isSearchStatus) &&
										(typeof footer === 'function' ? footer() : footer)}
                                </ul>
                            </div>,
                        ]
                    )}
                </div>
                {isSelectedShow && (typeof footer === 'function' ? footer() : footer)}
            </div>,
            <HotKeys
                keyMap={{
                    up: 'up',
                    down: 'down',
                    enter: 'enter',
                }}
                handlers={{
                    up: event => {
                        if (getStatus().isEdit) {
                            event.stopPropagation()
                            if (currentIndex > MIN_INDEX) {
                                this.setState(
                                    { currentIndex: currentIndex - 1 },
                                    () => {
                                        if (
                                            this.referScroll &&
											this.state.currentIndex * 30 < this.referScroll.scrollTop
                                        ) {
                                            this.referScroll.scrollTop = this.state.currentIndex * 30;
                                        }
                                    },
                                );
                            }
                        }
                    },
                    down: event => {
                        if (getStatus().isEdit) {
                            event.stopPropagation()
                            if (currentIndex < MAX_INDEX) {
                                this.setState(
                                    { currentIndex: currentIndex + 1 },
                                    () => {
                                        if (
                                            this.referScroll &&
											(this.state.currentIndex + 1) * 30 >
												this.referScroll.offsetHeight +
													this.referScroll.scrollTop
                                        ) {
                                            this.referScroll.scrollTop =
												(this.state.currentIndex + 1) * 30 -
												this.referScroll.offsetHeight;
                                        }
                                    },
                                );
                            }
                        }
                    },
                    enter: event => {
                        let status = getStatus();
                        if (status.isEdit) {
                            event.stopPropagation();
                            //延时导致event.target已被移出dom树因此在此先找一下父元素td，并保存一下
                            let td = this.props.renderInTable && findParentTd(event.target);
                            //阻止冒泡会影响Page/index 下的keydown 事件
                            //event.stopPropagation();
                            data[currentIndex] && onItemClick(data[currentIndex]);
                            if (
                                !(isMultiSelectedEnabled && status.isSearchStatus) ||
								(onEnter && status.isSearchStatus)
                            ) {
                                // 非多选的搜索状态
                                this.setState(
                                    { currentIndex: -1 },
                                    () => {
                                        // onEnter 逻辑添加 by bbqin
                                        let timer = setTimeout(() => {
                                            let currentTarget = td || event.target;
                                            if (
                                                executeEnterEvent({
                                                    containerDom,
                                                    onEnter,
                                                    currentTarget,
                                                })
                                            ) {
                                                onEnter({
                                                    e: event,
                                                    eventKey: 'Enter',
                                                    target: currentTarget,
                                                });
                                            }
                                            clearTimeout(timer);
                                        }, 20);
                                    },
                                );

                                if (this.lifecycleStatus === 'unmount' && onEnter) {
                                    onEnter({ target: td, eventKey: 'Enter' });
                                }
                                //bug 录入后enter键选择后值没有选上
                                /*if (executeEnterEvent({ containerDom, onEnter, currentTarget })) {
									onHotKeyClose();
								}*/
                            }
                        }
                    },
                }}
                attach={document.body}
                focused={true}
            />,
        ];
    }
}
